import produce, { Draft } from 'immer';

import {
  AuthenticateActionTypes,
  LOGGING_IN,
  LOGGED_IN,
  LOGGED_OUT,
  AuthenticationState,
  AuthenticationStatus,
  LOG_IN_FAILED,
} from '../types/auth';

const initialState: AuthenticationState = {
  status: AuthenticationStatus.none,
  user: undefined,
};

export const authenticationReducer = produce(
  (
    state: Draft<AuthenticationState>,
    action: AuthenticateActionTypes
  ): void => {
    switch (action.type) {
      case LOGGING_IN:
        state.status = AuthenticationStatus.authenticating;
        state.error = undefined;
        break;
      case LOGGED_IN:
        state.status = AuthenticationStatus.authenticated;
        state.error = undefined;
        state.user = action.payload;
        break;
      case LOGGED_OUT:
        state.status = AuthenticationStatus.anonymous;
        state.user = undefined;
        break;
      case LOG_IN_FAILED:
        state.status = AuthenticationStatus.failed;
        state.error = action.payload;
        break;
    }
  },
  initialState
);
